import React from "react";
import "./Navbar.scss"
import more from "../../assets/more.svg"
import { useHistory } from "react-router";
import Button from "../Button/Button";
import { useDispatch, useSelector } from "react-redux";
import { setIsComing } from "../../../../../../../redux/companyDataSlice";
import tt from "../../assets/tt.svg"
import insta from "../../assets/insta.svg"
const Navbar = ({ setIsMenuOpen }) => {
    const history = useHistory()
    const dispatch = useDispatch()
    const pages = useSelector((state) => state.companyData.pages)
    const company = useSelector((state) => state.companyData.company);
    const page = pages?.find((page) => page.PageId === "navbar")


    const leftComponent = page?.Components?.find((component) => component?.ID === "PapayaNavbar-Navbar")?.Props ?? null
    const linksComponent = page?.Components?.find((component) => component?.ID === "PapayaNavbar-Navbar-link")?.Data ?? []
    const buttonComponent = page?.Components?.find((component) => component?.ID === "PapayaNavbar-Navbar-button")?.Props ?? null

    return (
        <div className="PapayaNavbar">
            <div className="PapayaNavbar-wrapper">
                {leftComponent && <img alt=""
                    className="PapayaNavbar-wrapper-logo"
                    src={leftComponent?.src}
                    onClick={() => {
                        history.push(leftComponent?.href)
                    }} />}
                <div className="PapayaNavbar-wrapper-navs">
                    {linksComponent?.map((page) => {
                        return (
                            <div className={`PapayaNavbar-wrapper-navs-item ${window.location.pathname === page.href ? "papayanavselected" : ""}`}
                                onClick={() => {
                                    if (page?.href?.includes("https://")) {
                                        if (page?.href && page?.href !== "") {
                                            window.open(page?.href, '_blank')
                                        }
                                        else {
                                            dispatch(setIsComing(true))

                                        }
                                    } else {
                                        history.push(page?.href)
                                    }
                                }}>
                                {page.title}
                            </div>
                        )
                    })}
                </div>
                <div className="PapayaNavbar-wrapper-mobright">
                    <div className="PapayaNavbar-wrapper-mobright-list">
                        {company?.SocialMedias
                            ?.tiktok && company?.SocialMedias
                                ?.tiktok !== "" && <div
                                    onClick={() => {
                                        window.open(company?.SocialMedias
                                            ?.tiktok, '_blank')
                                    }} className="PapayaNavbar-wrapper-mobright-list-item">
                                <img alt="" src={tt} />
                            </div>}
                        {company?.SocialMedias
                            ?.instagram && company?.SocialMedias
                                ?.instagram !== "" && <div
                                    onClick={() => {
                                        window.open(company?.SocialMedias
                                            ?.instagram, '_blank')
                                    }} className="PapayaNavbar-wrapper-mobright-list-item">
                                <img alt="" src={insta} />
                            </div>}
                    </div>
                    <div
                        className="PapayaNavbar-wrapper-mobright-ic"
                        onClick={() => {
                            setIsMenuOpen(true)
                        }}
                    >
                        <img
                            className="PapayaNavbar-wrapper-mobright-ic-img"
                            alt=""
                            src={more} />
                    </div>
                </div>

                <div className="PapayaNavbar-wrapper-button">
                    <div className="PapayaNavbar-wrapper-list">
                        {company?.SocialMedias
                            ?.tiktok && company?.SocialMedias
                                ?.tiktok !== "" && <div
                                    onClick={() => {
                                        window.open(company?.SocialMedias
                                            ?.tiktok, '_blank')
                                    }} className="PapayaNavbar-wrapper-list-item">
                                <img alt="" src={tt} />
                            </div>}
                        {company?.SocialMedias
                            ?.instagram && company?.SocialMedias
                                ?.instagram !== "" && <div
                                    onClick={() => {
                                        window.open(company?.SocialMedias
                                            ?.instagram, '_blank')
                                    }} className="PapayaNavbar-wrapper-list-item">
                                <img alt="" src={insta} />
                            </div>}
                    </div>
                    {buttonComponent && <Button
                        text={buttonComponent?.buttonText}
                        onClick={() => {
                            if (buttonComponent?.href && buttonComponent?.href !== "") {
                                window.open(buttonComponent?.href, '_blank')
                            }
                            else {
                                dispatch(setIsComing(true))
                            }
                        }} />}
                </div>
            </div>

        </div>
    )
}
export default Navbar